import React from "react";
import ReactDOM from "react-dom";
import HexModal from "../../../app/components/modals/HexModal";
import ShowInvalidCSVModal from "../../../app/components/modals/employee/show-invalid-csv-modal";
import { addContextLog } from "../../../infrastructure/log";

function renderInvalidCSVModal(message) {
  ReactDOM.render(
    <HexModal>
      <ShowInvalidCSVModal message={message} />
    </HexModal>,
    document.getElementById("modal-container")
  );
}

export async function displayInvalidCSVModal(message) {
  addContextLog("info", "displayEmployeesPage", "display-screen", { message });
  renderInvalidCSVModal(message);
}
